import React, { useEffect } from 'react';
import './Footer.css';
import logo from '../../assets/images/Praveen Kumar Logo.png';
import linkedin from '../../assets/images/linkedin.png';
import github from '../../assets/images/github.png';
import instagram from '../../assets/images/instagram.png';
import facebook from '../../assets/images/facebook.png';
import twitter from '../../assets/images/twitter.png';
import whatsapp from '../../assets/images/Whatsapp round icon.png';
import { Link } from 'react-router-dom';

const Footer = () => {
  // Load Chatbase Script
  useEffect(() => {
    const chatbaseScript = document.createElement('script');
    chatbaseScript.src = 'https://www.chatbase.co/embed.min.js';
    chatbaseScript.async = true;
    chatbaseScript.defer = true;
    chatbaseScript.id = 's5CPqFFmpi3KIqVe6ZkuH';
    document.body.appendChild(chatbaseScript);

    return () => {
      document.body.removeChild(chatbaseScript);
    };
  }, []);

  // Load Google Translate Script
  useEffect(() => {
    if (!window.googleTranslateElementInit) {
      const script = document.createElement('script');
      script.src = '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
      script.async = true;
      document.body.appendChild(script);

      window.googleTranslateElementInit = () => {
        new window.google.translate.TranslateElement(
          {
            pageLanguage: 'en',
            includedLanguages: 'en,hi,ta,te,fr,de,es,zh,ar',
            layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
          },
          'google_translate_element'
        );
      };
    }
  }, []);

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-left">
          <img src={logo} alt="Logo" className="footer-logo" />
          <p className="footer-text">Praveen Kumar B</p>
        </div>

        <div className="footer-columns">
          <div className="footer-column">
            <h4>Navigation</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/projects">Projects</Link></li>
              <li><Link to="/skills">Skills</Link></li>
              <li><Link to="/events">Events</Link></li>
              <li><Link to="/blogs">Blogs</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4>Important Links</h4>
            <ul>
              <li><Link to="/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</Link></li>
              <li><Link to="/terms-conditions" target="_blank" rel="noopener noreferrer">Terms & Conditions</Link></li>
              <li><Link to="/cookie-policy" target="_blank" rel="noopener noreferrer">Cookie Policy</Link></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4>Follow Me On Social Media</h4>
            <div className="social-icons">
              <a href="https://www.linkedin.com/in/praveenkumarbofficial/" target="_blank" rel="noopener noreferrer"><img src={linkedin} alt="LinkedIn" /></a>
              <a href="https://github.com/praveenkumar-king/" target="_blank" rel="noopener noreferrer"><img src={github} alt="GitHub" /></a>
              <a href="https://www.instagram.com/praveen._.offical/" target="_blank" rel="noopener noreferrer"><img src={instagram} alt="Instagram" /></a>
              <a href="https://www.facebook.com/bpraveenkumar.praveenkumar.1" target="_blank" rel="noopener noreferrer"><img src={facebook} alt="Facebook" /></a>
              <a href="https://x.com/PraveenKum38515" target="_blank" rel="noopener noreferrer"><img src={twitter} alt="Twitter" /></a>
              <a href="https://under-construction-work.netlify.app/" target="_blank" rel="noopener noreferrer"><img src={whatsapp} alt="Whatsapp" /></a>
            </div>

            {/* Mail Icon and ID */}
            <div className="footer-email">
              <a href="mailto:praveenkumarbofficial@gmail.com" className="email-link" target="_blank" rel="noopener noreferrer">
                <img
                  src="https://cdn-icons-png.flaticon.com/512/561/561127.png"
                  alt="Mail"
                  className="email-icon"
                />
                praveenkumarbofficial@gmail.com
              </a>
            </div>

            <p className="footer-built-with">🚀 Built with <span className="heart">❤️</span> From Dharapuram</p>

            <div id="google_translate_element" className="google-translate-widget"></div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} <Link to="/" className="footer-home-link">Praveen Kumar B</Link>. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
